module.exports = __webpack_public_path__ + "static/media/context-menu.c574c8ab.svg";